import React, { useState } from 'react';
import Login from '../Auth/Login';
import Register from '../Auth/Register';
import '../../styles/Auth.css';

const AuthContainer = ({ onLogin }) => {
  const [showLogin, setShowLogin] = useState(true);

  return (
    <div className="auth-container">
      <div className="auth-shell">
        {showLogin ? (
          <Login onLogin={onLogin} onToggle={() => setShowLogin(false)} />
        ) : (
          <Register onToggle={() => setShowLogin(true)} />
        )}
      </div>
    </div>
  );
};

export default AuthContainer;
